import React from 'react'
import Headers from '../components/Headers'    // Adjust the path as needed
import Footer from '../components/Footer'      // Adjust the path as needed
// import { useSelector } from 'react-redux'   // If you need to bring in any Redux data

const AboutUs = () => {
  return (
    <div>
      {/* Reusable Header Component */}
      <Headers />

     {/* Banner / Hero Section */}
<section className="relative w-full h-[300px] md:h-[200px] bg-gray-200 flex items-center justify-center mt-10 md:mt-5">
  {/* Replace this with the street-market image of your choice */}
  <img
    src="/images/aboutusstreet.webp"
    alt="Street Market Banner"
    className="absolute w-full h-full object-cover top-0 left-0"
  />


        {/* Overlay for text, if desired */}
        <div className="absolute top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.4)]" />
        <div className="relative text-center text-white z-10">
          <h1 className="text-3xl md:text-2xl font-bold mb-2">About Us</h1>
          <p className="text-lg">Multi-Vendor E-commerce Marketplace</p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-16">
        <div className="w-[85%] lg:w-[90%] mx-auto">
          <div className="flex flex-col gap-6">
            {/* Description or Subtitle */}
            <h2 className="text-2xl font-bold text-slate-700">Who We Are</h2>
            <p className="text-slate-600 leading-relaxed">
              Welcome to our multi-vendor eCommerce platform! We are dedicated
              to bringing together a diverse community of sellers and buyers in
              one vibrant marketplace. From handcrafted goods to the latest
              fashion trends, our platform empowers entrepreneurs to showcase
              their unique products, while offering shoppers an unmatched
              selection from all corners of the market.
            </p>

            {/* More Sections or Blocks */}
            <h2 className="text-2xl font-bold text-slate-700 mt-8">Our Mission</h2>
            <p className="text-slate-600 leading-relaxed">
              Our mission is to create a seamlessly integrated online shopping
              experience that celebrates local artisans, budding startups, and
              established businesses alike. We strive to foster a supportive
              community where innovation, sustainability, and entrepreneurship
              can flourish.
            </p>

            <h2 className="text-2xl font-bold text-slate-700 mt-8">Why Shop With Us?</h2>
            <ul className="list-disc list-inside text-slate-600 leading-relaxed">
              <li>
                <strong>Variety:</strong> Explore thousands of categories, products,
                and desi styles in one place.
              </li>
              <li>
                <strong>Trust & Quality:</strong> Our vendors are verified and
                products go through quality checks.
              </li>
              <li>
                <strong>Community-Focused:</strong> We believe in building a strong
                network of customers and sellers who support and learn from each other.
              </li>
              <li>
                <strong>Secure Payment:</strong> Shop confidently with our 
                industry-standard secure checkout process.
              </li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-700 mt-8">Our Vision</h2>
            <p className="text-slate-600 leading-relaxed">
              We envision a world where online commerce transcends boundaries
              and empowers local and global communities. By using cutting-edge
              technology and forging strong relationships with vendors, we aim
              to be at the forefront of eCommerce innovation, bridging the gap
              between sellers and customers everywhere.
            </p>

            {/* Example of Additional Banner or Image Placeholders Below */}
            <div className="mt-8">
              {/* Keep this space if you want to add another image or section */}
              {/* <img 
                  src="/images/another-banner.jpg" 
                  alt="Additional Banner" 
                  className="w-full h-auto object-cover"
              /> */}
            </div>
          </div>
        </div>
      </section>

      {/* Reusable Footer Component */}
      <Footer />
    </div>
  )
}

export default AboutUs
